<template>
  <div class="mw-split-container mw-bar-data">
    <split-pane :defaultSize="150" split="vertical">
      <template slot="paneL">
        <mw-dialog ref="leadDialog" title="导出流程事务日志" size="mini_mini" :footerButton="leadButton">
          <div class="mw-toolbar_body" style="margin-top:20px;">
            <el-form label-width="100px">
              <el-col :span="24">
                <el-form-item label="开始时间">
                  <template>
                    <el-date-picker
                      v-model="startDate"
                      type="datetime"
                      placeholder="选择时间"
                      :picker-options="pickerBeginDateBefore">
                    </el-date-picker>
                  </template>
                </el-form-item>
              </el-col>

              <el-col :span="24">
                <el-form-item label="结束时间">
                  <template>
                    <el-date-picker
                      v-model="finishDate"
                      type="datetime"
                      placeholder="选择时间"
                      :picker-options="pickerBeginDateAfter">
                    </el-date-picker>
                  </template>
                </el-form-item>
              </el-col>

            </el-form>
          </div>
        </mw-dialog>

        <mw-dialog ref="findDialog" title="查询" size="small_small" :footerButton="findButton">
          <div class="mw-toolbar_body" style="margin-top:20px;">
            <el-form label-width="100px">
              <el-col :span="12">
                <el-form-item label="开始时间">
                  <template>
                    <el-date-picker
                      v-model="findOptions.startTime"
                      type="datetime"
                      placeholder="选择日期">
                    </el-date-picker>
                  </template>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="结束时间">
                  <template>
                    <el-date-picker
                      v-model="findOptions.endTime"
                      type="datetime"
                      placeholder="选择日期">
                    </el-date-picker>
                  </template>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="业务名称">
                  <template>
                    <el-input v-model="findOptions.businessNameLike"></el-input>
                  </template>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="模块">
                  <template>
                    <el-input v-model="findOptions.moduleNameLike"></el-input>
                  </template>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="流程">
                  <template>
                    <el-input v-model="findOptions.processDefinitionNameLike"></el-input>
                  </template>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="服务类">
                  <template>
                    <el-input v-model="findOptions.serviceClassLike"></el-input>
                  </template>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="方法名">
                  <template>
                    <el-input v-model="findOptions.methodNameLike"></el-input>
                  </template>
                </el-form-item>
              </el-col>
            </el-form>
          </div>
        </mw-dialog>

        <mw-dialog ref="dialog" size="large_large" title="查看事务日志"  :before-close="handleClose">
          <div class="mw-toolbar">
            <el-button @click="handleClose" type="primary"><i class="fa fa-mail-reply" type="primary"></i>关闭</el-button>
            <!--<el-button @click="save" type="primary"><i class="fa fa-save" type="primary"></i>保存</el-button>-->
            <el-button @click="reExecute" type="primary"><i class="fa fa-plus-square" type="primary"></i>提交</el-button>
          </div>
          <div class="mw-toolbar__body">
            <el-tabs type="card">
              <el-tab-pane>
                <span slot="label">基本信息</span>
                <el-form label-width="120px" style="width:90%;" class="mw-form"  :model="form" ref="form">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="文档ID:">
                        <el-input v-model="form.businessId" :readonly="true"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="文档题名:">
                        <el-input v-model="form.businessName" :readonly="true"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="模块:">
                        <el-input v-model="form.moduleName" :readonly="true"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="流程:">
                        <el-input v-model="form.processDefinitionName" :readonly="true"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item prop='id' v-show="false">
                        <el-input v-model="form.id" ></el-input>
                      </el-form-item>
                      <el-form-item label="起草文档ID:">
                        <el-input v-model="form.draftsDocId" :readonly="true"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="批次ID:">
                        <el-input v-model="form.batchId" :readonly="true"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="创建时间:">
                        <el-input v-model="form.createTime" :readonly="true"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="最后修改时间:">
                        <el-input v-model="form.lastModifiedTime" :readonly="true"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="服务类:">
                        <el-input v-model="form.serviceClass" :readonly="true"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="方法名:">
                        <el-input v-model="form.methodName" :readonly="true"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="异常内容:">
                        <el-input type="textarea" v-model="form.exceptionStack" :rows="15" :readonly="true"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </el-tab-pane>
              <el-tab-pane class="script-box">
                <span slot="label">提交数据</span>
                <mw-code-edit :value='methodArgs' lang="JSON" ref="methodArgs"></mw-code-edit>
              </el-tab-pane>
            </el-tabs>
          </div>
        </mw-dialog>
        <div class="mw-split-left">
          <div class="mw-toolbar">
            <el-button @click="expand"><i class="fa fa-angle-double-down"></i>展开</el-button>
            <el-button @click="closed"><i class="fa fa-angle-double-up"></i>折叠</el-button>
          </div>
          <div class="mw-toolbar__body">
            <mw-tree :url="treeUrl" :async="false" :multiple="false"  :selectFirst="true"
                     :defaultParams="params && params.requestParams"
                     :expandedFirst="true"   @changed="loadTableTree" ref="dictTree">
            </mw-tree>
          </div>
        </div>
      </template>
    <template slot="paneR">
      <div class="mw-split-right" >
      <toolbar-table :layout="layout" :autoLoad="false" ref="dataTable">
      </toolbar-table>
      </div>
    </template>
    </split-pane>
  </div>
</template>
<script>
  export default {
    props:{
      params:Object
    },
    data() {
      let me = this;
      return {
        layout: [],
        methodArgs:'',
        form: {
          id:'',
          draftsDocId:'',
          batchId:'',
          createTime:'',
          lastModifiedTime:'',
          serviceClass:'',
          methodName:'',
          exceptionStack:'',
          methodArgs:'',
          businessId:'',
          businessName:'',
          moduleName:'',
          processDefinitionName:''
        },
        appId:'',
        treeUrl:this.mwUrl("/api/maintain/listTreeFlowTransLog"),
        finishDate: '',
        startDate: '',
        leadButton: [
          {
            label: "取消",
            type: "default",
            func: this.closeLeadDialog
          },
          {
            label: "确定",
            func: this.leadSure
          }
        ],
        findButton: [
          {
            label: "取消",
            type: "default",
            func: this.closeFindDialog
          },
          {
            label: "确定",
            func:function(){
              let startTime=me.findOptions.startTime;
              let endTime=me.findOptions.endTime;
              me.findOptions.startTime=new moment(startTime).format("YYYY-MM-DD");
              me.findOptions.endTime=new moment(endTime).format("YYYY-MM-DD");
              me.findOptions.start=0;
              me.findOptions.limit=10;
              me.findOptions.conQuery=true;
              me.mwRef("dataTable").refreshTableDefaultParams(me.findOptions);
              me.closeFindDialog();
            }
          }
        ],
        //查询条件
        findOptions:{

        },
        pickerBeginDateBefore:{
          disabledDate(time) {
            if(me.finishDate != ''){
              return time.getTime() > me.finishDate
            }
          }
        },
        pickerBeginDateAfter:{
          disabledDate(time) {
            return time.getTime() < me.startDate
          }
        }
      };
    },
    mounted() {
      let me=this;
      //this.appId = this.$route.params.appId;
      me.layout=[
        [{
          span: 0,
          type: 'menu',
          api: 'maintain.listTransactionLog',
          defaultSort:[{sort:'createTime',dir:'asc'}],
          columns: [
            {type: 'selection'},
            {prop: 'createTime', label: '创建时间',width:'160'},
            {slot:{type:'href', func:me.view}, prop: 'serviceClass', label: '服务类',width:'300', tooltip:true},
            {prop: 'businessName', label: '文档题名',width:'180', tooltip:true},
            {prop: 'moduleName', label: '模块',width:'100'},
            {prop: 'processDefinitionName', label: '流程',width:'120'},
            {prop: 'exceptionMessage', label: '原因'}
          ]
        },{
          span: 10, type: 'button', items: [
            {
              label: "导出",
              icon: "fa fa-plus-square",
              func: me.lead
            },
            {
              label: "查询",
              icon: "fa fa-search",
              func: me.findInf
            },
            {label: '提交',icon:"fa fa-plus-square", func: me.vReExecute}]
        },
          {
            span: 6,
            type: "searchText",
            name: "name",
            tip:"文档题名",
            offset: 8
          }
        ]];
    },
    watch: {
      '$route'(to, from){
        this.appId = this.$route.params.appId;
      }
    },
    methods: {
      loadTableTree(data) {
        this.selectNode = data.id;
        let qp = {start:0,limit:20};
        if(!data.createYearMonth){
          qp.createYearMonth = data.id;
        }else{
          qp.createYearMonthDay = data.oldIdValue ? data.id : (data.createYearMonth+"-"+data.id);
        }
        let params=_.assign(qp,this.params && this.params.requestParams)
        this.mwRef("dataTable").refreshTableDefaultParams(params);
      },
      view(data) {
        let me=this;
        me.mwApi.maintain.getTransactionLog(data.id).then((res)=>{
          let d=res.result;
          me.form.id=d.id;
          me.form.draftsDocId=d.draftsDocId;
          me.form.batchId = d.batchId;
          me.form.createTime=d.createTime;
          me.form.lastModifiedTime=d.lastModifiedTime;
          me.form.serviceClass=d.serviceClass;
          me.form.methodName=d.methodName;
          me.form.exceptionStack=d.exceptionStack;
          me.methodArgs = js_beautify(d.methodArgs, {});
          me.form.businessId=d.businessId;
          me.form.businessName=d.businessName;
          me.form.moduleName=d.moduleName;
          me.form.processDefinitionName=d.processDefinitionName;
          me.mwRef('dialog').show();
        });
      },
      reExecute() {
        let me=this;
        me.methodArgs = me.mwRef('methodArgs').getValue();
        const loading = me.$loading({
          lock: false,
          fullscreen:false,
          text: '正在提交中，请耐心等待...',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0.5)'
        });
        me.mwApi.maintain.updateAndReExecute(me.form.id, me.methodArgs).then(res => {
          loading.close();
          if(res.success) {
            me.mwMsg("提交完成");
            me.mwRef('dialog').hide();
            me.mwRef('toolbarTable').refreshTable();
          } else {
            me.mwMsg('warning','提交失败');
          }
        }).catch(() => {
          loading.close();
        });
      },
      vReExecute(data){
        let me=this;
        if(data.length==0){
          me.mwMsg("info","请选择一条记录！");
          return ;
        }
        if(data.length>1){
          me.mwMsg("info","最多允许选择一条记录！");
          return ;
        }
        me.mwConfirm('您确定要提交所选记录').then(() => {
          let id=data[0].id;
          const loading = me.$loading({
            lock: false,
            fullscreen:false,
            text: '正在提交中，请耐心等待...',
            spinner: 'el-icon-loading',
            background: 'rgba(255, 255, 255, 0.5)'
          });
          me.mwApi.maintain.reExecute(id).then(res => {
            loading.close();
            if (res.success) {
              me.mwMsg("提交完成");
              me.mwRef('toolbarTable').refreshTable();
            } else {
              me.mwMsg('warning','提交失败');
            }
          }).catch(() => {
            loading.close();
          });
        }).catch(() => {
        });
      },
      lead() {
        var me=this;
        me.startDate="";
        me.finishDate="";
        this.mwRef("leadDialog").show();
      },

      leadSure(){
        var me=this;
        if(!me.startDate && !me.finishDate){
          me.mwMsg("warning", '请选择开始时间或结束时间!');
          return;
        }
        var params={};
        if(me.startDate)
          params.startTime=new moment(me.startDate).format("YYYY-MM-DD");
        if(me.finishDate)
          params.endTime=new moment(me.finishDate).format("YYYY-MM-DD");

      if(me.params && me.params.requestParams && me.params.requestParams.includeUsers)
        params.includeUsers = me.params.requestParams.includeUsers;
      if(me.params && me.params.requestParams && me.params.requestParams.excludeUsers)
        params.excludeUsers = me.params.requestParams.excludeUsers;

        this.mwApi.maintain.expFlowTransLog(params);
        this.closeLeadDialog();
      },
      closeLeadDialog(){
        this.mwRef("leadDialog").hide();
      },

      closeFindDialog(){
        this.findOptions={};
        this.mwRef('findDialog').hide()
      },

      findInf(){
        this.findOptions={};
        this.mwRef("findDialog").show();
      },
      handleClose(){
        var me = this;
        this.mwRef("dialog").hide();
      },
      expand() {
        this.mwRef('dictTree').openAll();
      },
      closed() {
        this.mwRef('dictTree').closeAll();
      },
      format(date){
        if(!(date instanceof Date)){
          return '';
        }
        let year=date.getFullYear();
        let month=date.getMonth()+1;
        let day=date.getDate();
        let hour=date.getHours();
        let min=date.getMinutes();
        let second=date.getSeconds();
        month=(month>=10?"":"0")+month;
        day=(day>=10?"":"0")+day;
        hour=(hour>=10?"":"0")+hour;
        min=(min>=10?"":"0")+min;
        second=(second>=10?"":"0")+second;
        return parseInt(year+month+day);
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/modules/index/views/systemSet/log/flowTransLog.vue